import { Folder as FolderType } from '@/api/generatedApi';
import { StyledPopover } from '@/components/AssetsPage/PopoverList';
import { usePopover } from '@/hooks/usePopover';
import { AssetsPageObjectModel } from '@/poms/assetsPageObjectModel';
import { Add } from '@mui/icons-material';
import { Box, Tooltip, useTheme } from '@mui/material';
import { useSimpleModal } from '@/hooks/useModal';
import { ActionIconButton } from '../IconButton';
import { CreateFolderModal } from '../modals/CreateFolderModal';
import { NewItemMenuContent } from './NewItemMenuContent';

export const CreateContentButton = ({
  isZeroState,
  parentFolder,
  handleFileUpload,
  handleFolderUpload,
}: {
  isZeroState?: boolean;
  parentFolder?: FolderType;
  handleFileUpload: () => void;
  handleFolderUpload: () => void;
}) => {
  const {
    open: openNewItemPopover,
    close: closeNewItemPopover,
    isOpen: isNewItemPopoverOpen,
    anchorElement: newItemPopoverAnchorElement,
  } = usePopover();

  const createFolderModal = useSimpleModal();
  const theme = useTheme();

  const handleNewFolderClick = () => {
    createFolderModal.open();
  };

  return (
    <>
      <Box>
        <Tooltip title='New ...' placement='bottom'>
          <span>
            <ActionIconButton
              onClick={openNewItemPopover}
              data-testid={AssetsPageObjectModel.AddButton}
              enablePulse={isZeroState}
              enableShadow
            >
              <Add sx={{ fontSize: '18px', color: theme.palette.text.primary }} />
            </ActionIconButton>
          </span>
        </Tooltip>
        <StyledPopover
          open={isNewItemPopoverOpen}
          anchorEl={newItemPopoverAnchorElement}
          onClose={closeNewItemPopover}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          slotProps={{
            paper: {
              sx: {
                marginLeft: '20px',
                marginTop: '0px',
                borderRadius: '12px',
              },
            },
          }}
        >
          <NewItemMenuContent
            onClose={closeNewItemPopover}
            onNewFolderClick={handleNewFolderClick}
            onFileUpload={handleFileUpload}
            onFolderUpload={handleFolderUpload}
          />
        </StyledPopover>
      </Box>
      <CreateFolderModal
        isOpen={createFolderModal.isOpen}
        onClose={createFolderModal.close}
        parentFolder={parentFolder}
      />
    </>
  );
};
